angular.module('cfn').directive('cfnInputDate', [
  'calendarService',
  function(calendarService) {
    return {
      restrict: 'E',
      scope: {
        model: '=',
        afterLink: '=',
        beforeLink: '=',
        class: '@',
        readonly: '=',
        required: '@',
        change: '&',
        changemonth: '&',
        beforeday: '&',
        beforeshow: '&',
        isdisabled: '&',
        from: '=',
        to: '='
      },
      replace: true,
      template:
        '<input type="text" cfn-enter-tab class="{{class}} cfn-input-date" ng-disabled="{{readonly}}" show-weeks="false" ng-class="{\'validate[required]\':required}" ng-required="{{required}}"/>',
      link: function(scope, element, attrs) {
        // Remove readonly="false", which is bad HTML
        if (!scope.readonly) {
          element.removeAttr('readonly');
        }

        // link between multiple dates to ensure one is after or before another
        scope.$watch('afterLink', function(value) {
          if (value) {
            var date = new Date(scope.model);
            var afterDate = new Date(scope.afterLink);
            date.setHours(0, 0, 0, 0);
            afterDate.setHours(0, 0, 0, 0);
            if (date > afterDate) {
              date.setDate(afterDate.getDate());
              date.setMonth(afterDate.getMonth());
              date.setFullYear(afterDate.getFullYear());
              scope.model = date.getTime();
            }
          }
        });

        scope.$watch('beforeLink', function(value) {
          if (value) {
            var date = new Date(scope.model);
            var beforeDate = new Date(scope.beforeLink);
            date.setHours(0, 0, 0, 0);
            beforeDate.setHours(0, 0, 0, 0);
            if (date < beforeDate) {
              date.setDate(beforeDate.getDate());
              date.setMonth(beforeDate.getMonth());
              date.setFullYear(beforeDate.getFullYear());
              scope.model = date.getTime();
            }
          }
        });

        // Init
        // $.datepicker.setDefaults(calendarService.getDatePickerConfig());
        function attachDatepicker() {
          element.datepicker({
            minDate: scope.from,
            maxDate: scope.to,
            changeMonth: true,
            changeYear: attrs.changeYear !== 'false',
            beforeShow: scope.beforeshow ? scope.beforeshow() : null,
            beforeShowDay: scope.beforeday ? scope.beforeday() : null,
            onChangeMonthYear: scope.changemonth ? scope.changemonth() : null,
            yearRange: '1900:2050'
          });
        }

        ang.callAfter(function() {
          attachDatepicker();
          scope.$watch(
            'from',
            function(newValue, oldValue) {
              if (newValue !== oldValue) {
                element.datepicker('option', 'minDate', newValue);
              }
            },
            false
          );

          scope.$watch(
            'to',
            function(newValue, oldValue) {
              if (newValue !== oldValue) {
                element.datepicker('option', 'maxDate', newValue);
              }
            },
            false
          );

          scope.$watch(
            'model',
            function() {
              // Propagate change of angular model to date picker
              if (scope.model) {
                var date = new Date(scope.model);
                // Update datepicker.
                if (date != element.datepicker('getDate')) {
                  element.datepicker('setDate', date);
                }
              } else {
                element.datepicker('setDate', null);
              }
            },
            false
          );

          // Propagate change of input field to angular model
          element.change(function() {
            ang.apply(scope, function() {
              //try{
              var date = element.datepicker('getDate');
              if (date) {
                // if valid date
                scope.model = date.getTime();
              } else {
                scope.model = null;
              }
              if (scope.required) {
                element.validationEngine('validate');
              }
            });
            ang.apply(scope, function() {
              scope.change();
            });
          });
        }, scope);
      }
    };
  }
]);
